import { Component, Inject, OnInit } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';
import { ExportToCsv } from 'export-to-csv';
import { ElementSchemaRegistry } from '@angular/compiler';
import { DatePipe } from '@angular/common'
import { ExcelService } from 'src/app/excel.service';
type AOA = any[][];

@Component({
  selector: 'app-overallptpreport',
  templateUrl: './overallptpreport.component.html',
  styleUrls: ['./overallptpreport.component.css'],
  providers: [DatePipe]
  
})
export class OverallptpreportComponent implements OnInit {


  record_count: number = 0;
  count_down = 0;
  final_datas = [];

  final_datas1 =  [];
  origianl_bank_list = [];
  original_portfolio_list = [];
  loader_status = false;



  constructor(    private excelService: ExcelService,public datepipe: DatePipe,private _api:ApiService, @Inject(SESSION_STORAGE) private storage: StorageService,) { }

  show_loader = true;
  FollowUpList : any;
  user_list: any = [];
  agent_search : any;
  ptp_end_date : any;
  ptp_start_date : any;

  ngOnInit(): void {
    this.portfolio_list_get();
    this.bank_list_get();


    this._api.user_details_list().subscribe(
      (response: any) => {
        this.user_list = response.Data;
      }
    );

 
  }



  getFromLocal(key): any {
    return this.storage.get(key);
  }

  datesearch(){
    console.log(this.ptp_start_date);
    let final_data = [];
    this.final_datas1 = [];
    this.count_down = 0;
    let login_Details = this.getFromLocal("login_Details");
    console.log(login_Details);
    let end_date =  new Date(this.ptp_start_date+'T01:00:00.000Z');
    end_date.setDate(end_date.getDate() + 1);
    var dataFormat = {
      start_date : new Date(this.ptp_start_date+'T01:00:00.000Z'),
      end_date : new Date(end_date),
      agent_id : login_Details._id,
    };
    console.log(dataFormat);
    this._api.Overall_getFollowUpReport(dataFormat).subscribe(data=>{
      console.log(data);
      if (data['Code']==200) {
         this.FollowUpList = data['Data'];
         if (this.FollowUpList.length == 0){
          alert("No record Found");
        }
         this.FollowUpList.forEach(element => {
          element.no_of_count = 1
         });

         for(let a = 0 ; a < this.FollowUpList.length; a++){
             if(a == 0){
               final_data.push(this.FollowUpList[a]);
             }else{
              let check_status = 0;
              let temp_count = final_data.length;
              for(let b = 0 ; b < temp_count; b++){
                if(a < this.FollowUpList.length){
                  // console.log(this.FollowUpList[a].finterstal_id);
                  // console.log(final_data[b].finterstal_id);
                  if(this.FollowUpList[a].finterstal_id == final_data[b].finterstal_id){
                    check_status = 1;
                    final_data[b].no_of_count =  final_data[b].no_of_count + 1;
                  }
                  if(b == temp_count - 1){
                    if(check_status == 0){
                      final_data.push(this.FollowUpList[a]);
                    }
                  }
                }
              }
             }
             if(a == this.FollowUpList.length - 1){
               this.final_datas = final_data;
               if(this.final_datas.length == 0){
               alert("No record Found");
               }
               this.record_count = final_data.length;
               this.loader_status = true;
               this.final_datas1 = [];
               this.call_fech_data()
             }
         }
      } else {
        this.FollowUpList = [];
      }
    });

  }



  call_fech_data(){   
   console.log(this.count_down,this.final_datas.length);
   if(this.count_down !== this.final_datas.length){
    console.log(this.final_datas[this.count_down]);
    let a  = {
      finterstal_id : this.final_datas[this.count_down].finterstal_id
    }
    this._api.fetch_data_search(a).subscribe((data:any)=> {
    console.log(data);
    var obj = JSON.parse(data.Data.customer.customer_details)
    obj = obj[0];
    console.log(obj);
    let porfolio_name = '';
    this.original_portfolio_list.forEach(element => {
      if(element._id == this.final_datas[this.count_down].portfolio_id){
        porfolio_name = element.portfolio_type
      }
    });
    let  datas = {
       finterstal_id : this.final_datas[this.count_down].finterstal_id,
       Bank : this.final_datas[this.count_down].bank_id.bank_name,
       Portfolio: porfolio_name,
       Product : data.Data.customer.product_name,
       CIF : data.Data.customer.cif,
       CID :'',
       Acc_Number :data.Data.customer.acc_no,
       Name: obj.Customer_Name,
       TOS : data.Data.customer.total_out_standing,
       POS: obj.PRINCIPLE_AMT,
       CL : obj.creditlimit,
       Current_Date :this.ptp_start_date,
       Last_Status_of_that_day  : this.final_datas[this.count_down].mstatus,
       Last_SubStatus_of_that_day : this.final_datas[this.count_down].substatus,
       Follow_Up_date : this.final_datas[this.count_down].ptp_status,
       This_Day_remark_only : this.final_datas[this.count_down].remarks,
       Agent : this.final_datas[this.count_down].createdby.name,
       No_of_attemptes_for_the_day : this.final_datas[this.count_down].no_of_count
    }
    this.final_datas1.push(datas);
    this.count_down = this.count_down + 1;
    this.call_fech_data();
    });
   }else{
    this.loader_status = false;
   }


   
  


  }




  


  clear(){

  }


  exportPTPreport(){
  
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.final_datas1,'Follow UP Report');
  }


  portfolio_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.portfolio_type_list(a).subscribe(
      (response: any) => {
        this.original_portfolio_list = response.Data;
      }
    );
  }


bank_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(
      (response: any) => {
        this.origianl_bank_list = response.Data;
      }
    );
  }

}
